import {Button} from 'antd';
import {ROUTES} from '../../utils/ROUTES';
import {useNavigate} from 'react-router-dom';
const SquareCta = ({text = 'Get started with Permworks'}: {text: string}) => {
	const navigate = useNavigate();
	return (
		<div className="flex justify-center items-center">
			<div className="bg-permhunt-no-border w-[890px] max-w-full p-4 min-h-[220px] rounded-lg flex flex-col justify-center items-center gap-6">
				<p className="text-white text-center text-2xl font-normal">{text}</p>
				<Button
					type="primary"
					className="h-[40px] w-full max-w-[500px] bg-white/90 text-deepBlue hover:bg-backgroundGreyBlue/20 border-white/20 hover:text-white border-1 mt-3 mb-2 font-semibold"
					onClick={() => navigate(ROUTES.POST_JOB)}>
					Post a free job ad
				</Button>
			</div>
		</div>
	);
};

export default SquareCta;
